import { render, staticRenderFns } from "./SupportPagination.vue?vue&type=template&id=10105ebe&scoped=true&"
import script from "./SupportPagination.vue?vue&type=script&lang=js&"
export * from "./SupportPagination.vue?vue&type=script&lang=js&"
import style0 from "./SupportPagination.vue?vue&type=style&index=0&id=10105ebe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10105ebe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
